import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardPageComponent } from './pages/giftcard/giftcard.page';
import { GiftcardListComponent } from './components/giftcard-list/giftcard-list.component';
import { Routes, RouterModule } from '@angular/router';
import { GeneralModule } from './../general/general.module';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { GiftCardOdooService } from './services/giftcard-odoo.service';
import { GiftCardInMemoryService } from './services/giftcard-in-memory.service';
import { GiftCardService } from './services/giftcard.service';
import { GiftCardStepService } from './services/giftcard-step.service';
import { GiftcardComponent } from './components/giftcard/giftcard.component';
import { GiftcardLoginComponent } from './components/giftcard-login/giftcard-login.component';
import { GiftcardRegisterComponent } from './components/giftcard-register/giftcard-register.component';
import { GiftcardLoginGuard } from './guards/giftcard-login.guard';
import { GiftcardRegisterGuard } from './guards/giftcard-register.guard';
import { GiftCardOrderComponent } from './components/giftcard-order/giftcard-order.component';
import { GiftcardOrdedrGuard } from './guards/giftcard-order.guard';
import { GiftcardCustomComponent } from './components/giftcard-custom/giftcard-custom.component';
import { OrderModule } from '../order/order.module';
import { LoginModule } from '../login/login.module';
import { FormsModule } from '@angular/forms';
import { PaymentModule } from '../payment/payment.module';
import { PartnerModule } from '../partner/partner.module';
import { GiftCardListElementComponent } from './components/giftcard-list-element/giftcard-list-element.component';
import { GiftcardGuard } from './guards/giftcard.guard';
import { PartnerCodeModule } from '../partner-code/partner-code.module';
import { ShopModule } from '../shop/shop.module';


const routes: Routes = [
  {
    path: 'giftcard',
    component: GiftcardPageComponent,
    data: {
      title: ['NAME COMPANY', 'GiftCards']
    },
    children: [
      {
        path: '',
        canActivate: [GiftcardGuard],
        children: [
          {
            path: 'order',
            component: GiftCardOrderComponent,
            canActivate: [GiftcardOrdedrGuard],
            data: { title: ['Basket'] },
          },
          {
            path: 'login',
            component: GiftcardLoginComponent,
            canActivate: [GiftcardLoginGuard],
            data: { title: ['NAME COMPANY', 'Login'] },
          },
          {
            path: 'register',
            component: GiftcardRegisterComponent,
            canActivate: [GiftcardRegisterGuard],
            data: { title: ['NAME COMPANY', 'REGISTRATION'] },
          },
          {
            path: '',
            component: GiftcardComponent,
            data: { title: ['NAME COMPANY', 'GiftCards'] },
          },
          {
            path: '**',
            redirectTo: '/giftcard',
            pathMatch: 'full'
          },
        ]
      }
    ]
  },
];

const giftCardServiceClass = environment.production ? GiftCardOdooService : GiftCardInMemoryService;

@NgModule({
  imports: [
    LoginModule,
    OrderModule,
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    HttpClientModule,
    GeneralModule,
    FormsModule,
    PaymentModule,
    PartnerModule,
    PartnerCodeModule,
    ShopModule,
  ],
  declarations: [
    GiftcardPageComponent,
    GiftcardListComponent,
    GiftCardOrderComponent,
    GiftcardCustomComponent,
    GiftcardComponent,
    GiftcardLoginComponent,
    GiftcardRegisterComponent,
    GiftCardListElementComponent,
  ],
  providers: [
    GiftcardGuard,
    GiftcardOrdedrGuard,
    GiftcardLoginGuard,
    GiftcardRegisterGuard,
    GiftCardStepService,
    [{ provide: GiftCardService, useClass: giftCardServiceClass }],
  ],
})
export class GiftcardModule { }
